import React from 'react';

import { Progress } from 'antd';

import styled from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';
import { NwTag } from '@components/Gui/NwTag';
import StyleVariables from '@components/Gui/StyleVariables';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const StyledProgress = styled(Progress)`
    .ant-progress-text {
        width: auto;
        font-size: ${(props) => props.theme.FontSizeSm};
        font-weight: normal;
        color: ${(props) => props.theme.TextColorMuted};
        margin-left: 0.25rem;

        span.steps-text {
            font-size: ${(props) => props.theme.FontSizeXSm};
        }
    }
`;

export const CheckListProgress = ({ checkListStatus }) => (
    <StyledProgress
        percent={checkListStatus.percent}
        steps={checkListStatus.total}
        size="small"
        strokeColor={StyleVariables.SuccessColor}
        trailColor={StyleVariables.DangerColor}
        format={() => {
            if (checkListStatus.complete) {
                return <NwIcon icon={byPrefixAndName.fass['check-circle']} color={StyleVariables.SuccessColor} />;
            } else {
                return <span className="steps-text">{checkListStatus.text}</span>;
            }
        }}
    />
);

export const CheckListTag = ({ checkListStatus }) => (
    <NwTag type={checkListStatus.complete ? 'success' : 'danger'} style={{ marginLeft: '.5em' }}>
        {checkListStatus.text}
    </NwTag>
);
